import { GetCurrenciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCurrencies = () => {
  const { loading, data, refetch } = useQuery(GetCurrenciesDocument)

  const currencies = data ? data.apiCore.currenciesConnection.edges.map((edge) => edge.node) : []

  return {
    loading,
    currencies,
    refetch,
  }
}
